import React, { useState, useEffect } from 'react';
import { Box, Fab, useTheme } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { motion, AnimatePresence } from 'framer-motion';

const MotionFab = motion(Fab);

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <Box
          sx={{
            position: 'fixed',
            bottom: { xs: 20, sm: 30 },
            right: { xs: 20, sm: 30 },
            zIndex: theme.zIndex.appBar + 1
          }}
        >
          <MotionFab
            onClick={scrollToTop}
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            sx={{
              background: `linear-gradient(135deg, rgba(63, 160, 255, 0.9), rgba(34, 87, 140, 0.9))`,
              border: '1px solid rgba(63, 160, 255, 0.3)',
              backdropFilter: 'blur(8px)',
              boxShadow: '0 4px 20px rgba(63, 160, 255, 0.3)',
              '&:hover': {
                background: `linear-gradient(135deg, rgba(63, 160, 255, 1), rgba(34, 87, 140, 1))`,
                boxShadow: '0 6px 25px rgba(63, 160, 255, 0.5)',
                transform: 'translateY(-2px)',
                '& .MuiSvgIcon-root': {
                  transform: 'translateY(-2px)',
                  filter: 'brightness(1.2)'
                }
              },
              '&:active': {
                transform: 'translateY(1px)',
                boxShadow: '0 2px 10px rgba(63, 160, 255, 0.3)'
              }
            }}
          >
            <KeyboardArrowUpIcon
              sx={{
                color: '#fff',
                fontSize: '2rem',
                transition: 'all 0.3s ease',
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
              }}
            />
          </MotionFab>
        </Box>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;
